<template>
  <div class="div_input_mobile flex" :class="worring ? 'input_worring' : ''">
    <el-input
      v-model="mobile"
      @focus="worring = false"
      @input="inputPhone"
      size="large"
      class="key_input"
      type="text"
      maxlength="16"
      :value="props.modelValue"
    >
      <!-- :placeholder="props.placeholder ? props.placeholder : props.modelValue" -->
    </el-input>
    <div class="nub">{{ props.modelValue?props.modelValue.length:0 }} / 16</div>
  </div>
</template>

<script setup>
import { defineProps, defineEmits, ref, onMounted, defineExpose } from "vue";

const props = defineProps(["modelValue", "placeholder"]);
const emit = defineEmits(["update:modelValue"]);

let mobile = ref(props.modelValue);
let worring = ref(false);
console.log(mobile.value);

onMounted(() => {
  mobile.value = props.modelValue;
});

function inputPhone() {
  emit("update:modelValue", mobile.value);
}

defineExpose({
  worring,
});
</script>

<style lang='scss' scoped>
.div_input_mobile {
  height: 60px;
  border-radius: 10px 10px 10px 10px;
  border: 1px solid transparent;
  overflow: hidden;
  user-select: none;
  transition: all $anim-time-fn-ease-out 0.25s;
  position: relative;
}
.input_worring {
  border: 1px solid #f56c6c;
}
.nub {
  position: absolute;
  right: 15px;
  color: #b9bbbe;
}
</style>
